import { render, staticRenderFns } from "./SidebarPanels.vue?vue&type=template&id=26163e31&"
import script from "./SidebarPanels.vue?vue&type=script&lang=ts&"
export * from "./SidebarPanels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports